


































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import {
	Entities,
	Product,
	ProductStatus,
	SimproJobDetails,
	SimproJobDetailsJobTypeEnum,
} from '@/api';
import { ProductStatusService } from '@/services/product-status-service';

import RouterLinkButton from '@/components/elements/buttons/router-link-button.vue';
import { Constants } from '@/common/Constants';
import { SimproJobService } from '@/services/simpro-job-service';
import Toast from '@/components/display/toast.vue';
import { SimproService } from '@/services/simpro-service';

@Component({
	computed: {
		ProductStatus() {
			return ProductStatus;
		},
	},
	components: {
		RouterLinkButton,
	},
})
export default class ProductActionsBar extends Vue {
	@Prop({ required: true, type: Array })
	public entityTypes!: Entities[];

	@Prop({ required: true, type: Object })
	private product!: Product;

	public async created(): Promise<void> {
		await this.watchProduct();
	}

	protected loadingEligibleForRepair: boolean = true;
	protected eligibleForInstall: boolean = false;
	protected eligibleForRepair: boolean = false;
	protected eligibleForRemoval: boolean = false;

	public jobModals = [
		{ id: 'installJobModal', jobType: Constants.JOB_TYPE_INSTALL },
		{ id: 'repairJobModal', jobType: Constants.JOB_TYPE_REPAIR },
		{ id: 'removeJobModal', jobType: Constants.JOB_TYPE_REMOVAL },
	];

	private toast = new Toast();
	private productStatusService = new ProductStatusService(this.product);
	private simproJobService = new SimproJobService(this.product);
	private simproService = new SimproService();

	@Watch('product', { deep: true })
	public async watchProduct() {
		this.productStatusService = new ProductStatusService(this.product);

		let jobs:
			| SimproJobDetails[]
			| { errorMessage: string } = await this.simproJobService.loadSimproJobs();
		if ('errorMessage' in jobs) {
			this.loadingEligibleForRepair = false;
			this.toast.makeToast(jobs.errorMessage, 'Error Loading SimPRO Jobs', 'danger');
			return;
		}

		jobs = await this.simproService.getSimproJobDetails(jobs, this.axios, this.product);

		this.eligibleForInstall = this.productStatusService.canCreateInstallJobs;
		this.eligibleForRepair =
			this.productStatusService.eligibleForRepair &&
			!jobs.some(
				(job: SimproJobDetails) =>
					job.jobType === SimproJobDetailsJobTypeEnum.Repair && job.completedAt == null,
			);
		this.eligibleForRemoval = this.productStatusService.liveEntities;

		this.loadingEligibleForRepair = false;
	}

	public showAddJobModal(jobType: 'install' | 'repair' | 'remove'): void {
		const modalId = this.jobModals.find(modal => modal.jobType === jobType)?.id;
		if (!modalId) {
			return;
		}
		this.$bvModal.show(modalId);
	}

	public showAddFaultModal(): void {
		this.$bvModal.show('faultModal');
	}

	public async showAddEntityModal(entityType: Entities): Promise<void> {
		this.$bvModal.show(`addEntityModal_${entityType}`);
	}
}
